import React from "react"

import { ShareProjectOverlay } from "./ShareProjectOverlay"
import { useShareProjectOverlayModel } from "./hooks/useShareProjectOverlayModel"

export interface ShareProjectOverlayPayload {
  projectID: string
  isShareID?: boolean
}

export interface ShareProjectOverlayConnectorProps {
  payload: ShareProjectOverlayPayload
}

export const ShareProjectOverlayConnector = React.memo(
  (props: ShareProjectOverlayConnectorProps) => (
    <ShareProjectOverlay {...useShareProjectOverlayModel(props)} />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    SHARE_OVERLAY: ShareProjectOverlayPayload
  }
}
